var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1018 5.31129C22.7317 5.94119 22.7317 6.96414 22.1018 7.59404L9.20148 20.4943C8.57158 21.1242 7.54863 21.1242 6.91873 20.4943L0.468578 14.0442C-0.16132 13.4143 -0.16132 12.3913 0.468578 11.7614C1.09848 11.1315 2.12143 11.1315 2.75133 11.7614L8.06262 17.0677L19.8241 5.31129C20.454 4.68139 21.4769 4.68139 22.1068 5.31129H22.1018Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5755,
    height: 25.8006,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPayment);
export default __webpack_public_path__ + "static/media/check_payment.b2ad9cd985b35e245a93cd7e9089f9b8.svg";
export { ForwardRef as ReactComponent };